import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Event as EventInterface } from '@planone/bau365/util-fair-data';
import { combineTags, Tag } from '@planone/shared/util-interfaces';

@Component({
  selector: 'bau365-event-section-info',
  templateUrl: './section-info.component.html',
  styleUrls: ['./section-info.component.scss'],
})
export class SectionInfoComponent implements OnChanges {
  @Input() event?: EventInterface;
  @Input() chipsListClickable = true;

  tags: Tag[] = [];

  ngOnChanges(changes: SimpleChanges) {
    const event: EventInterface = <EventInterface>changes['event']['currentValue'];

    if (event) {
      this.tags = combineTags(event.topics, event.product_groups, event.professions);
    }
  }
}
